import { Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box } from "@mui/material";

import { type WorkerVisitLockMessageProps } from "../type";
import { parseAgentChatMessage } from "../utils";

export function WorkerVisitLockMessage(props: WorkerVisitLockMessageProps) {
  const { message } = props;

  if (!isDefined(message)) {
    return null;
  }

  const messageText = parseAgentChatMessage(message);

  if (!isDefined(messageText)) {
    return null;
  }

  return (
    <Box
      sx={(theme) => ({
        padding: theme.spacing(5),
        marginBottom: theme.spacing(2),
        background: theme.palette.secondary.main,
        borderRadius: theme.borderRadius?.leftChatMessage,
      })}
    >
      <Text variant="body1" color="text.primary" sx={{ whiteSpace: "pre-line" }}>
        {messageText}
      </Text>
    </Box>
  );
}
